import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-feather',
  templateUrl: './feather.component.html',
  styleUrls: ['./feather.component.scss']
})

/**
 * Feather component - handling the feather icon  with navbar and content
 */
export class FeatherComponent implements OnInit {
  // bread crumb items
  breadCrumbItems: Array<any>;

  constructor() { }

  ngOnInit() {
    this.breadCrumbItems = [{ label: 'Aivis', path: '/' }, { label: 'Icons', path: '/' }, { label: 'Feather', path: '/', active: true }];

  }

}
